import { styled, TextField } from "@material-ui/core";

export const StyledTextField = styled(TextField)({
	"& .MuiInputBase-input": {
		width: "100%",
	},
  "& label, label.Mui-focused": {
    color: "#4D4C4D"
  },
  "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": {
    color: "#4D4C4F !important"
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#4D4C4F"
  },

  "& .MuiOutlinedInput-root, .MuiInputBase-root": {
    "& fieldset": {
      color: "#4D4C4F",
      borderWidth: "1px",
      borderColor: "#4D4C4D",
    },
    "&.Mui-focused fieldset": {
      color: "#4D4C4F",
      borderColor: "#4D4C4F",
      borderWidth: "1px"
    }
  }
});
